import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// components
import { LoadingScreen } from 'src/commons/components/loading-screen';
// context
import { StepPhoneTopupProvider } from 'src/features/phone-topup/context/step-context';
import { FormProvider } from 'src/features/phone-topup/context/form-provider';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/features/phone-topup'));

// ----------------------------------------------------------------------

export const phoneTopupRoutes = [
  {
    path: '/phone-topup',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        element: (
          <FormProvider>
            <StepPhoneTopupProvider>
              <IndexPage />
            </StepPhoneTopupProvider>
          </FormProvider>
        ),
        index: true,
      },
    ],
  },
];
